// extracted by mini-css-extract-plugin
export default {"topDetailItemContainer":"TopDetailItem_topDetailItemContainer__UvbPb","title":"TopDetailItem_title__riLAw","value":"TopDetailItem_value__olAGx"};